export const SECTIONS = [
  {
    title: 'About Blink',
    className: 'col-sm-6 col-lg-2',
    links: [
      {
        label: 'About us',
        url: '/about-us',
        id: 'about-us',
      },
      {
        label: 'How Blink Works',
        url: '/how-blink-works',
        id: 'how-blink-works',
      },
      {
        label: 'BlinkRx',
        url: '/blinkrx',
        id: 'blinkrx',
      },
    ],
  },
  {
    title: 'Company',
    className: 'col-sm-6 col-lg-2',
    links: [
      {
        label: 'Blog',
        url: '/blog',
        id: 'blog',
      },
      {
        label: 'Careers',
        url: '/careers',
        id: 'careers',
      },
      {
        label: 'Press',
        url: '/in-the-press',
        id: 'in-the-press',
      },
      {
        label: 'Testimonials',
        url: '/testimonials',
        id: 'testimonials',
      },
    ],
  },
];
